import { IApplicationState } from '../../types/redux';

export const selectPromoCompilationLogoUrls = (state: IApplicationState): string[] => {
  const {
    promosPage: {
      topPromos: { providers },
    },
  } = state;

  return providers.map(provider => provider.logoUrl);
};
